import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import VerifiedBadge from "@/components/VerifiedBadge";
import Portrait from "@/components/Portrait";
import BeyondScreen from "@/components/BeyondScreen";
import Services from "@/components/Services";
import SkillStats from "@/components/SkillStats";
import Packages from "@/components/Packages";
import Showcase from "@/components/Showcase";
import Faq from "@/components/Faq";
import Manifesto from "@/components/Manifesto";
import Marquee from "@/components/Marquee";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#0A1730] text-[#F3EFE6] antialiased">
      <div className="noise-overlay" />
      <Nav />
      <main>
        <Hero />
        <VerifiedBadge />
        <Portrait />
        <BeyondScreen />
        <Services />
        <SkillStats />
        <Packages />
        <Showcase />
        <Manifesto />
        <Marquee />
        <Testimonials />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <Toaster position="bottom-right" theme="dark" richColors />
    </div>
  );
}
